<template>
  <div>
    <v-card class="mt-3" style="display: flex;  justify-content: space-between;">
      <div class="pa-3 mt-2 aulas-title">
        <div><strong>Ano:</strong> {{ ano }}</div>
      </div>
       <div class="pr-3 pb-3 aulas-title" v-if="form.cdturma != '0'" style=" text-align: center;">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }" >
                  <!-- <span>Efetuar Frequência</span> -->
                  <v-icon v-bind="attrs" v-on="on" size="20" >notification_important</v-icon>
                </template>
                <span class="text-caption white--text">Estas datas são correspondentes a data de abertura e fechamento do diário,<br> não
                  representam os períodos letivos conforme o calendário escolar.
                </span>
            </v-tooltip>
        <div v-for="fechamento in CAA" :key="fechamento.cdpravadi" >
          <strong  class="capitalize">{{capitalizePeriodo(fechamento.dspravadi)}}:</strong> {{fechamento.datainicio | formatDataBR}} a
          {{fechamento.datafim | formatDataBR}}
        </div>
        </div>
    </v-card>
    <v-alert type="error" :value="errorText !== '' || msgArrayError.length > 0" dark class="mt-3 mb-3">
      <div v-if="errorText !== ''">{{ errorText }}</div>
      <div v-if="msgArrayError.length > 0">
        <div><strong>{{ nomeMsgError }}</strong></div>
        <ul v-for="error of msgArrayError" :key="error.key" style="margin-left: 10px;">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>
    <div class="mt-3 aulas-btns">
      <div>
        <v-btn  icon :to="{ name: 'diario-escolar', params: { paginaAtualTurmas }}">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </div>
      <div style="text-align: right">
      </div>
    </div>
    <v-card class="mt-3">
      <v-card-text>
        <Validator label="Lançamento de aulas/frequência por:*" >
          <Radio label="Turma" v-model="lancamentoPorTurmaOuDisciplina" val="turma" @input="tipoDeLancamentoChange() " />
          <Radio label="Disciplina/Campos de Experiência" v-model="lancamentoPorTurmaOuDisciplina" val="disciplina" @input=" tipoDeLancamentoChange()" />
        </Validator>
        <Select
          label="Turmas*"
          :options="turmasOptions"
          v-model="form.cdturma"
          v-if="lancamentoPorTurmaOuDisciplina === 'turma'"
          :disabled="loading"
          @change="atualizaTipoDeEnsino(turmasOptions, form.cdturma); fecharDialogFrequenciaPorTurma()"
        />

        <Select
          label="Disciplinas/Campos de Experiência*"
          :options="disciplinasOptions"
          v-model="form.cddiscipl"
          v-if="lancamentoPorTurmaOuDisciplina === 'disciplina'"
          :disabled="loading"
        />

        <Select
          label="Períodos Avaliativos*"
          :options="periodosOptions"
          :disabled="validarSelectPeriodos"
          v-model="form.cdpravadi"
          @change="setTipoEnsino()"
        />
        <div v-if="this.form.AEEouACP">
          <MultipleSelect label="Alunos*" :options="form.alunosDaTurma" :v="$v.alunosSelecionados"
                @change="form.alunosDaTurma = $event; alunosSelecionados = form.alunosDaTurma.filter(e => e.selecionado === true);"
                :disabled="this.loading || form.alunosDaTurma.length === 0" />
          <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }">
                  <!-- <span>Efetuar Frequência</span> -->
                  <v-icon v-bind="attrs" v-on="on" size="20" >notification_important</v-icon>
                </template>
                <span class="text-caption white--text">Caso algum dos alunos selecionados tiverem alguma situação que não permite frequência,<br>
                eles estarão bloqueados para recebê-la.<br>
                Ex: um aluno que já foi transferido não terá frequência lançada.</span>
              </v-tooltip>

        </div>

        <InputDate v-if="form.cntpensin === 'I' && form.cdturma" label="Data" v-model.trim="form.dataaula" :v="(form.cntpensin === 'I') ? $v.form.dataaula : ''" />
        <div>
            <Input class="assuntoLecionado" v-if="form.cntpensin === 'I' && form.cdturma"  label="Assunto Lecionado *" type="text"  v-model.trim="form.descricaoassuntolecionado" :v="$v.form.descricaoassuntolecionado"/>
            <v-tooltip text="Tooltip" location="top">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="abrirDialogDetalhamentoAula()" v-show="form.cntpensin === 'I' && form.cdturma !== '' && form.cdturma !== 0 " :disabled="form.dataaula == '' || form.descricaoassuntolecionado == ''" :style="(errorText !== '' || msgArrayError.length > 0) && $v.form.datareposicao.$invalid ? 'border: 2px solid #b00020 !important; color: white;' : 'color: white;' " class="btnDetalhamento second"  >
                  <v-icon>settings</v-icon>
                </v-btn>
              </template>
              <span>Detalhamento da aula</span>
            </v-tooltip>
        </div>

        <Validator style="margin-bottom: -15px;" v-if="form.cntpensin === 'I' && form.cdturma" label="Aula presencial?" >
          <Radio label="Sim" v-model="form.indicapresencial" val="S" :disabled="indicamodelodeaula === 'R' || indicamodelodeaula === 'P' " @input="lancarIndicaPresenca()"/>
          <Radio label="Não" v-model="form.indicapresencial" val="N" :disabled="indicamodelodeaula === 'R' || indicamodelodeaula === 'P'" @input="lancarIndicaPresenca()"/>
        </Validator>
      </v-card-text>
      <v-card-text style="overflow-y: auto">
        <table class="table-siged" v-if="tabela.length > 0 && form.cdpravadi != 0 && this.lancamentoPorTurmaOuDisciplina === 'turma'">
          <thead>
            <tr>
              <th colspan="2">{{ showCampoExperiencia() ? 'Campos de Experiência' : 'Disciplinas ministradas'}}</th>
              <th  v-if="form.cntpensin !== 'I'">Data</th>
              <th>Qtde</th>
              <th  v-if="form.cntpensin !== 'I'">Assunto Lecionado</th>
              <th v-if="form.cntpensin !== 'I' && form.cdturma">Aula Presencial?</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(disciplina, index) in tabela" :key="disciplina.id" >
              <td style="width: 150px;">{{disciplina.dsdiscipl}}</td>
              <td class="centro" style="width: 20px;">
                <CheckBox v-model="disciplina.check" :val="1" @input="resetRow(index)" />
              </td>
              <td class="centro" style="width: 140px" v-if="form.cntpensin !== 'I'">
                <InputDateTable
                  label="Data"
                  style="width: 100%"
                  :disabled="!disciplina.check || form.cntpensin === 'I'"
                  v-model="disciplina.dataaula"
                  :v="$v.disciplinas.$each[index].dataaula"
                  :msgsError="msgValidacao(validations.$each[index].dataaula)"
                  @blur="$v.disciplinas.$each[index].dataaula.$touch()"
                />
              </td>
              <td class="centro" style="width: 20px; padding: 0">
                <InputTable
                  type="number"
                  style="width: 60%"
                  :disabled="!disciplina.check"
                  v-model="disciplina.quantidade"
                  :msgsError="msgValidacao($v.disciplinas.$each[index].quantidade)"
                  @blur="$v.disciplinas.$each[index].quantidade.$touch()"
                  min="0"
                />
              </td>

              <td v-if="form.cntpensin !== 'I'">
                <InputTable
                  type="text"
                  label="Assunto Lecionado"
                  class="text_center"
                  style="width: 100%"
                  maxlength="400"
                  :disabled="!disciplina.check || form.cntpensin === 'I'"
                  v-model="disciplina.descricaoassuntolecionado"
                  :msgsError="msgValidacao($v.disciplinas.$each[index].descricaoassuntolecionado)"
                  @blur="$v.disciplinas.$each[index].descricaoassuntolecionado.$touch()"
                />
              </td>
              <td  v-if="form.cntpensin !== 'I'" class="centro" style="width: 10px">
                 <div>
                    <td class="centro" style="border-style: none; vertical-align: middle; text-align: center; padding:0px ">
                        <Radio label="Sim" v-model="disciplina.indicapresencial" val="S" :disabled="!disciplina.check || indicamodelodeaula === 'R' || indicamodelodeaula === 'P' "/>
                    </td>
                    <td class="centro" style="border-style: none; vertical-align: middle; text-align: center; padding:0px">
                        <Radio label="Não" v-model="disciplina.indicapresencial" val="N" :disabled="!disciplina.check || indicamodelodeaula === 'R' || indicamodelodeaula === 'P'" />
                    </td>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table-siged" v-if="tabela.length > 0 && form.cdpravadi != 0 && this.lancamentoPorTurmaOuDisciplina === 'disciplina' && this.loading === false">
          <thead>
            <tr>
              <!-- <th>teste</th> -->
              <th colspan="2">Turmas</th>
              <th>Data</th>
              <th>Qtde</th>
              <th>Assunto Lecionado</th>
              <th>Aula Presencial?</th>
              <th v-if="tabela.filter((e) => e.AEEouACP === true).length > 0 && this.loading === false && form.alunosDaTurma.length > 0" width="5%">Alunos</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(turma, index) in tabela" :key="turma.id" >
              <td style="width: 150px;">{{turma.nmturma}} {{getTurno(turma.cnperiodo)}}</td>
              <td class="centro" style="width: 20px;">
                <CheckBox v-model="turma.check" :val="1" @input="resetRowTurma(index)" :data-index="index" @click.native="event => onClickInput(event, index)"/>
              </td>
              <td class="centro" style="width: 140px" v-if="form.cntpensin !== 'I'">
                <InputDateTable
                  label="Data"
                  style="width: 100%"
                  :disabled="!turma.check"
                  v-model="turma.dataaula"
                  :msgsError="msgValidacao($v.turmas.$each[index].dataaula)"
                  @blur="$v.turmas.$each[index].dataaula.$touch()"
                  :data-index="index"
                  @click.native="event => onClickInput(event, index)"
                  @keydown="e => prevenirIncrementoInputNumber(e)"
                />
              </td>

              <td class="centro" style="width: 20px; padding: 0">
                <InputTable
                  type="number"
                  style="width: 60%"
                  :disabled="!turma.check"
                  v-model="turma.quantidade"
                  :msgsError="msgValidacao($v.turmas.$each[index].quantidade)"
                  @blur="$v.turmas.$each[index].quantidade.$touch()"
                  :data-index="index"
                  @click.native="event => onClickInput(event, index)"
                  min="0"
                  @keydown="e => prevenirIncrementoInputNumber(e)"

                />
              </td>
              <td v-if="form.cntpensin !== 'I'">
                <!-- o atributo :data-index="index" tem a função de marcar a coordenada do elemento para navegação com as setas do teclado -->
                <InputTable
                  type="text"
                  label="Assunto Lecionado"
                  class="text_center"
                  style="width: 100%"
                  maxlength="400"
                  :disabled="!turma.check || form.cntpensin === 'I'"
                  v-model="turma.descricaoassuntolecionado"
                  :msgsError="msgValidacao($v.turmas.$each[index].descricaoassuntolecionado)"
                  @blur="$v.turmas.$each[index].descricaoassuntolecionado.$touch()"
                  :data-index="index"
                  @click.native="event => onClickInput(event, index)"
                />
              </td>
              <td class="centro" style="width: 10px">
                 <div>
                    <td class="centro" style="border-style: none; vertical-align: middle; text-align: center; padding:0px ">
                      <Radio label="Sim" v-model="turma.indicapresencial" val="S" :disabled="!turma.check || turma.indicamodelodeaula === 'R' || turma.indicamodelodeaula ==='P'" :data-index="index" @click.native=" event => onClickRadioButtonInput(event, index)"  />
                    </td>
                    <td class="centro" style="border-style: none; vertical-align: middle; text-align: center; padding:0px">
                      <Radio label="Não" v-model="turma.indicapresencial" val="N" :disabled="!turma.check || turma.indicamodelodeaula === 'R' || turma.indicamodelodeaula ==='P'" :data-index="index" @click.native="event => onClickRadioButtonInput(event, index)" />
                    </td>
                  </div>
              </td>
              <td v-if="turma.AEEouACP && turma.alunosDaTurma.length > 0" class="text-center" >
                <!-- v-if="$v.turmas.$each.$iter[index].alunosDaTurma.$each.$iter[index].$invalid && $v.turmas.$each.$iter[index].alunosDaTurma.$each.$iter[index].$dirty" -->
                <!-- $v.turmas.$each[index].alunosDaTurma.$each[index].$invalid && $v.turmas.$each[index].alunosDaTurma.$each[index].$dirty -->
                <v-tooltip color="#E64D4D"
                    :disabled="!($v.turmas.$each[index].alunosDaTurma.$each[index].$invalid && $v.turmas.$each[index].alunosDaTurma.$each[index].$dirty)"
                    bottom
                >
                  <template v-slot:activator="{ on }" >
                    <v-btn color="#E64D4D"
                      v-show="$v.turmas.$each[index].alunosDaTurma.$each[index].$invalid && $v.turmas.$each[index].alunosDaTurma.$each[index].$dirty"
                      icon class="btn_icone_vermelho"
                      @click="exibirDialogListaDeAlunos(turma)"
                      v-on="on"
                      :disabled="!turma.check || turma.dataaula.length !== 10">
                      <v-icon color="#FFF">person_add</v-icon>
                    </v-btn>
                    <v-btn color="#01848C"
                      icon class="btn_icone_verde"
                      v-show="!($v.turmas.$each[index].alunosDaTurma.$each[index].$invalid && $v.turmas.$each[index].alunosDaTurma.$each[index].$dirty)"
                      @click="exibirDialogListaDeAlunos(turma)"
                      :disabled="!turma.check || turma.dataaula.length !== 10">
                      <v-icon color="#FFF">person_add</v-icon>
                    </v-btn>
                  </template>
                  <span>
                      Nenhum aluno foi selecionado
                  </span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </table>

      </v-card-text>
        <div class="btn-acoes-b">
          <v-btn class="rounded-sm font-weight-regular" type="button" color="primary" small :disabled="aulasCadastradas.length <= 0" @click="dialog = true" v-if="lancamentoPorTurmaOuDisciplina === 'turma'">Frequência</v-btn>
          <v-btn class="rounded-sm font-weight-regular" type="button" color="primary" small :disabled="aulasCadastradas.length <= 0" @click="dialogPorTurma = true" v-if="lancamentoPorTurmaOuDisciplina === 'disciplina'">Frequência</v-btn>
          <v-btn class="rounded-sm font-weight-regular" type="submit" color="teal" small :loading="loading" :disabled="validaSalvar || desabilitarSalvar"  @click="onSubmit()">Salvar</v-btn>
          <v-btn class="rounded-sm font-weight-regular" type="button" small @click="cancelar()" :disabled="validaSalvar">Cancelar</v-btn>
        </div>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span style="font-size: 19px!important">Lançar Frequência</span>
        </v-card-title>

        <form @submit.prevent="lancarFrequencia">
          <v-card-text>
            <table class="table-siged">
              <thead>
                <tr>
                  <th><CheckBoxCustom true-value="S" false-value="N" v-model="selecionarTodasAulas" @input="marcarTodasAulas()"/></th>
                  <th>Código</th>
                  <th>{{showCampoExperiencia() ? 'Campos de Experiência' : 'Disciplinas'}}</th>
                  <th>Data</th>
                  <th>Assunto Lecionado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="aula in aulasCadastradas" :key="aula.id">
                   <td v-if="aula.aberto === false" class="centro">FECHADO</td>
                  <template v-else>
                  <td class="centro">
                    <span v-if="aula.liberadoFrequencia">
                      <CheckBox v-model="aulasParaFrequencia" :val="aula.identificadoraula" @input="checkAula()"/>
                    </span>
                    <span v-else><v-icon title="Data Futura">lock</v-icon></span>
                  </td>
                  </template>
                  <td>{{ aula.identificadoraula }}</td>
                  <td>{{ aula.disciplina.dsdiscipl }}</td>
                  <td>{{ aula.dataaula | formatDataBR }}</td>
                  <td>{{ aula.descricaoassuntolecionado }}</td>
                  <td> <v-icon size="20" style="vertical-align: top">{{ (aulasFrequenciaLancada.find( element => element === aula.identificadoraula)) ? 'check' : 'remove' }}
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card-text>

          <v-card-actions class="btn-acoes-b">
            <v-spacer></v-spacer>
            <v-btn class="rounded-sm font-weight-regular" color="teal" type="submit" small :loading="loadingFrequencia" :disabled="aulasParaFrequencia.length <= 0">Lançar</v-btn>
            <v-btn class="rounded-sm font-weight-regular" small @click="dialog = false">Cancelar</v-btn>
            <v-btn class="rounded-sm font-weight-regular" small @click="fecharDialogFrequenciaPorTurma()">Fechar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPorTurma" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2 fixed">
          <span style="font-size: 19px!important">Lançar Frequência</span>
        </v-card-title>

        <form @submit.prevent="lancarFrequencia">
          <v-card-text>
            <table class="table-siged">
              <thead class="fixed" style="" >
                <tr>
                  <th></th>
                  <th>Código</th>
                  <th>Turma</th>
                  <th>Data</th>
                  <th>Assunto Lecionado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="aula in aulasCadastradas" :key="aula.id">
                   <td v-if="aula.aberto === false" class="centro">FECHADO</td>
                  <template v-else>
                  <td class="centro">
                    <span v-if="aula.liberadoFrequencia">
                      <!-- <Radio name="aulaid" :val="aula.identificadoraula" @input=" aulasParaFrequencia = aula.identificadoraula "  /> -->
                     <CheckBox v-model="aulasParaFrequencia" name="aulaid" :val="aula.identificadoraula" @input="habilitarCheckBoxPorTurma(aula)" :disabled="aula.cdturma !== form.cdturma && aulasParaFrequencia.length > 0" />
                    </span>
                    <span v-else><v-icon title="Data Futura">lock</v-icon></span>
                  </td>
                  </template>
                  <td>{{ aula.identificadoraula }}</td>
                  <td>{{ aula.cdturma }}</td>
                  <td>{{ aula.dataaula | formatDataBR }}</td>
                  <td>{{ aula.descricaoassuntolecionado }}</td>
                  <td> <v-icon size="20" style="vertical-align: top">{{ (aulasFrequenciaLancada.find( element => element === aula.identificadoraula)) ? 'check' : 'remove' }}
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
            <v-card-actions class="btn-acoes-b fixed-bottom"  >
              <v-spacer></v-spacer>
                <v-btn class="rounded-sm font-weight-regular" color="teal" type="submit" small :loading="loadingFrequencia" :disabled="aulasParaFrequencia.length <= 0">Lançar</v-btn>
                <v-btn class="rounded-sm font-weight-regular" small @click="dialogPorTurma = false">Cancelar</v-btn>
                <v-btn class="rounded-sm font-weight-regular" small @click="fecharDialogFrequenciaPorDisciplina()">Fechar</v-btn>
            </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetalhamentoAula" scrollable persistent max-width="500px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span style="font-size: 19px!important">Detalhar Aula</span>
        </v-card-title>
        <v-card-text class=" pa-4" style="max-height: 770px; height: 100vh;">
          <div  ref="alerta" style="margin-top: -25px">&nbsp;</div>
          <v-alert  type="error" :value="errorTextDetalhamento !== ''" dark class=" mb-3">
            <div v-if="errorTextDetalhamento !== ''">{{ errorTextDetalhamento }}</div>
          </v-alert>
          <form class="formDetalhamentoAula">
            <InputDate label="Data" v-model.trim="form.dataaula" disabled :v="(form.cntpensin === 'I') ? $v.form.dataaula : '' " />
            <Input label="Assunto Lecionado *" type="text"  v-model.trim="form.descricaoassuntolecionado" disabled />
            <TextArea v-model="form.descricaodesenvolvimentoaula" label="Desenvolvimento da aula" :v="$v.form.descricaodesenvolvimentoaula"/>
            <TextArea v-model="form.descricaorecursosutilizados" label="Recursos utilizados" :v="$v.form.descricaorecursosutilizados"/>
            <TextArea v-model="form.descricaoatividadeassociada" label="Atividade Associada" :v="$v.form.descricaoatividadeassociada"/>
            <TextArea v-model="form.descricaoobjetivo" label="Objetivo" :v="$v.form.descricaoobjetivo"/>
            <Validator label="Reposição?" :v="$v.form.indicareposicao">
              <Radio label="Sim" v-model="form.indicareposicao" val="S" />
              <Radio label="Não" v-model="form.indicareposicao" val="N" @click="form.datareposicao = ''; $v.form.datareposicao.$reset()" />
            </Validator>
            <InputDate v-model="form.datareposicao" :disabled="form.indicareposicao === 'N'" label="Referente a data" :v="(form.cntpensin === 'I') ? $v.form.datareposicao : ''"/>
            <Validator label="Situação" :v="$v.form.indicasituacao">
              <Radio label="Elaboração" disabled v-model="form.indicasituacao" val="E" />
              <Radio label="Exibida para o público" disabled v-model="form.indicasituacao" val="P" />
            </Validator>
            <TextArea label="Observação" v-model="form.descricaoobservacao" :v="$v.form.descricaoobservacao"/>
          </form>
        </v-card-text>
        <v-card-actions class="btn-acoes-b" style="border-top: 1px solid #ddd;">
          <v-spacer></v-spacer>
          <v-btn class="rounded-sm font-weight-regular" color="teal" small @click="LancarDetalhamento()" >Lançar</v-btn>
          <v-btn class="rounded-sm font-weight-regular" small @click="CancelarDetalhamento()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exibirDialogAlunos" persistent max-width="500px" scrollable  >
      <v-card>
        <v-card-title class="headline grey lighten-4 mb-4"  >
          <div>
            <CheckBoxCustom label="Selecionar todos" @click="toggle" :value="todosSelecionados" :true-value="true" :false-value="false" />
          </div>
        </v-card-title>
        <v-card-text>
            <div v-for="(op) in opcoes" :key="op.key" >
              <CheckBox v-model="op.selecionado"
              :label="(!op.disabled) ? op.title : `${op.title} - ${op.observacaoDesabilitado}`"
              :val="op.value" :disabled="op.disabled"/>
            </div>
        </v-card-text>
        <v-divider></v-divider>
          <v-card-actions  class="d-flex justify-center" >
            <v-btn class="rounded-sm font-weight-regular white--text" color="teal" small @click="fecharDialogo" >OK</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex';
import store from '@/store/index';
import InputTable from '@/components/InputTable';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { required, requiredIf, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import { lessThen } from '@/validations';
import { ehTurmaAEEouACP } from '@/utils/turmas'
import _ from 'lodash';

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');
const PeriodoAvaliativoRepository = RepositoryFactory.get('periodoAvaliativo');
const DisciplinaRepository = RepositoryFactory.get('disciplina');
const TurmaRepository = RepositoryFactory.get('turma');
const DisciplinaDispensadaRepository = RepositoryFactory.get('disciplinaDispensada')

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const setFormInicial = (props) => ({
  identificadoraula: '',
  ...dadosUser(),
  aaletivo: props.ano,
  cdturma: '0',
  nmturma: '',
  cdpravadi: '0',
  cntpensin: props.tipoDeEnsino,
  cdinstruc: 0,
  indicaativo: 'S',
  check: false,
  descricaoassuntolecionado: '',
  dataaula: '',
  indicareposicao: 'N',
  tipodeensino: props.tipoDeEnsino,
  indicacampoexperiencia1: 'N',
  indicacampoexperiencia2: 'N',
  indicacampoexperiencia3: 'N',
  indicacampoexperiencia4: 'N',
  indicacampoexperiencia5: 'N',
  indicapresencial:'',
  descricaodesenvolvimentoaula: '',
  descricaorecursosutilizados: '',
  descricaoatividadeassociada: '',
  descricaoobjetivo: '',
  datareposicao: '',
  indicasituacao: 'E',
  descricaoobservacao: '',
  cddiscipl: 0,
  alunosDaTurma: [],
  AEEouACP: '',
});

export default {
  name: 'AulasRegente',
  props: {
    ano: [String, Number],
    paginaAtualTurmas: [String, Number],
    tipoDeEnsino: [String],
    //aulasFrequenciaLancada: [Array],
    aulasParaLancarFrequencia: [Array],
    frequenciaLancada:[Array],
    turmaOuDisciplina: [String],
    cdturma: [String],
  },
  components: {
    InputTable,
  },
  data() {
    return {
      quantidadeAulasPermitidas: 6,
      nomeMsgError: '',
      errorText: '',
      errorTextDetalhamento: '',
      dadosTurmas: '',
      periodoAvaliativo: '',
      form: setFormInicial(this.$props),
      alunosSelecionados: [],
      alunosDispensados: [],
      formDetalhamentoCopia: {},
      acao: true,
      loading: false,
      disciplinas: [],
      disciplinasCopy: [],
      snackbar: false,
      submitText: '',
      msgArrayError: [],
      aulasCadastradas: [],
      aulasParaFrequencia: [],
      dialog: false,
      dialogPorTurma: false,
      dialogDetalhamentoAula: false,
      dialogDetalhamentoFechando: false,
      loadingFrequencia: false,
      tipodeensino: '',
      CAA:'',
      selecionarTodasAulas: 'N',
      aaletivo: this.ano,
      lancamentoPorTurmaOuDisciplina: '',
      turmas: [],
      turmasCopy: [],
      aulasFrequenciaLancada: this.frequenciaLancada || [],
      frequenciasALancar: this.aulasParaLancarFrequencia || [],
      linhaX: 0,
      linhaY: 0,
      indicamodelodeaula: '',
      configuracaoAnoLetivoPorInstrucao: [],
      desabilitarSalvar : true,
      exibirDialogAlunos: false,
      opcoes: [],
      cdturma_aux: '',

    }
  },
  created() {
   document.addEventListener("keyup", this.onKeyUp);
    this.$Progress.finish();
    this.loadTurmas();

    if(this.frequenciasALancar.length > 0) {
      this.aulasCadastradas = this.frequenciasALancar;

      if (this.turmaOuDisciplina === 'turma') {
        this.dialog = true;
        this.dialogPorTurma = false;
        this.lancamentoPorTurmaOuDisciplina = 'turma';
      }
      else if(this.turmaOuDisciplina === 'disciplina') {
        this.dialogPorTurma = true;
        this.dialog = false;
        this.lancamentoPorTurmaOuDisciplina = 'disciplina';

      }

    }
  },
  destroyed() {
    document.removeEventListener("keyup", this.onKeyUp);
  },
  watch: {
    'form.cdturma'(newVal, oldVal) {
      if(newVal !== 0) {
        const turma = this.dadosTurmas.filter((e) => {
          return e.cdturma === this.form.cdturma
          })[0]
        this.form.AEEouACP = ehTurmaAEEouACP(turma.cdtpatend, turma.cdinstruc, turma.cdserie)

        this.loadPeriodos();
        this.disciplinas = [];
        this.form.cdpravadi = 0;
        this.desabilitarSalvar = false;

      }
    },
    'form.cddiscipl'(newVal, oldVal) {
      if(newVal !== 0) {
        this.loadPeriodos();
       // this.disciplinas = [];
        this.form.cdpravadi = 0;
        this.desabilitarSalvar = false;
      }
    },
    'form.cdpravadi'(newVal, oldVal) {
      if(newVal !== 0) {
        this.desabilitarSalvar = false;
        this.loadTabela();
      }
    },

  },
  validations() {
    return {
      alunosSelecionados: {required: requiredIf(vm => vm.form.AEEouACP === true),},

    disciplinas: {
      $each: {
        dataaula: {
          required: function(value, disciplina) {
            return !(disciplina.check) || (disciplina.dataaula != '')
          },
          isValidDate: function(value, disciplina) {
            if((disciplina.check ) && (disciplina.dataaula !== ''))
              return  moment(value, 'DD/MM/YYYY').isValid()
            else return true

          }
        },
        quantidade: {
          required: function(value, disciplina) {
            return !(disciplina.check) || (disciplina.quantidade != '')
          },
          minValue: minValue(1),
          // maxValue: maxValue(6),
          maxValue: function(value, disciplina) {
            let VALID = false;
            if(disciplina.cntpensin === 'I') {
              VALID = value <= 10 ? true : false;
            } else {
              VALID = value <= 6 ? true : false;
            }
            // console.log('Valid', VALID)
            return VALID;
          }
        },
        descricaoassuntolecionado: {
          required: function(value, disciplina) {
            return !(disciplina.check) || (disciplina.descricaoassuntolecionado != '')
          },
          maxLength: maxLength(400),
        },
        indicapresencial: {
          required: function(value, disciplina) {
            return !(disciplina.check) || (disciplina.indicapresencial != '')
          },
        //  maxLength: maxLength(400),
        },
      }
    },
    turmas: {
      $each: {
        dataaula: {
          required: function(value, turma) {
            return !(turma.check) || (turma.dataaula != '')
          },
          isValidDate: function(value, turma) {
            if((turma.check ) && (turma.data !== ''))
              return  moment(value, 'DD/MM/YYYY').isValid()
            else return true

          }
        },
        quantidade: {
          required: function(value, turma) {
            return !(turma.check) || (turma.quantidade != '')
          },
          minValue: minValue(1),
          // maxValue: maxValue(6),
          maxValue: function(value, turma) {
            let VALID = false;
            if(turma.cntpensin === 'I') {
              VALID = value <= 10 ? true : false;
            } else {
              VALID = value <= 6 ? true : false;
            }
             //console.log('Valid', VALID)
            return VALID;
          }
        },
        descricaoassuntolecionado: {
          required: function(value, turma) {
            return !(turma.check) || (turma.descricaoassuntolecionado != '')
          },
          maxLength: maxLength(400),
        },
        indicapresencial: {
          required: function(value, turma) {
            return !(turma.check) || (turma.indicapresencial != '')
          },
        //  maxLength: maxLength(400),
        },
        alunosDaTurma: {
          $each: {
                  alunos: {
                      minValue: function(a, b) {
                        const check = this.turmas.filter( turma => turma.cdturma === b.cdturma).map( e => e.check)[0] === true
                        return (check && this.lancamentoPorTurmaOuDisciplina === 'disciplina') ? Object.values(a).filter(e => e.selecionado === true).length > 0 : true

                      }
                  },
          },

        },
      }
    },
    form: {
        descricaoassuntolecionado: { maxLength: maxLength(400) },
        descricaodesenvolvimentoaula: { maxLength: maxLength(400) },
        descricaorecursosutilizados: { maxLength: maxLength(400) },
        descricaoatividadeassociada: { maxLength: maxLength(400) },
        descricaoobjetivo: { maxLength: maxLength(600) },
        indicareposicao: { required },
        dataaula: {required,
                  isValidDate: (value) => ((!value)) ? true : moment(value, 'DD/MM/YYYY').isValid()
                  },
        datareposicao: { required: ( (this.form.indicareposicao == 'S') ? required : '' ),
                         isValidDate:  (value) => (this.form.indicareposicao == 'S') ? moment(this.form.datareposicao, 'DD/MM/YYYY').isValid() : true,
                         maxLength: maxLength( 10 ),
                         lessThen: lessThen( moment(this.form.dataaula,'DD/MM/YYYY').format('YYYY-MM-DD') )
                       },
        indicasituacao: { required },
        descricaoobservacao: { maxLength: maxLength(400) }
      },
    }
  },
  methods: {
    lancarIndicaPresenca() {
      this.tabela.filter(element => {
        return element.check == true;
      });
    },
    tipoDeLancamentoChange() {
      if (this.lancamentoPorTurmaOuDisciplina === 'turma') {
        this.form.cddiscipl = 0;
      }
      else {
        this.form.cdturma = 0;
        this.form.alunosDaTurma = [];
        this.alunosSelecionados = [];
        this.form.AEEouACP = '';
      }
      this.form.cdpravadi = 0;

      this.aulasCadastradas = [];

    },
    habilitarCheckBoxPorTurma(aula) {
      //this.aulasParaFrequencia.push(aula.identificadoraula);
      this.form.cdturma = aula.cdturma;

    },
    marcarTodasAulas() {
      if ( this.selecionarTodasAulas === 'S' ) {
        this.aulasCadastradas.forEach( (aula) => {
          if ( aula['aberto'] && aula['liberadoFrequencia'] ) this.aulasParaFrequencia.push(aula['identificadoraula'])
        } );
      }
      else this.aulasParaFrequencia = [];

      const identificadorAula = this.aulasParaFrequencia[0]
      const aula = this.aulasCadastradas.filter( a => a.identificadoraula === identificadorAula)[0]
      if(aula) {
        const turmas = [...this.dadosTurmas]
        const turma = turmas.filter(t => t.cdturma === aula.cdturma)[0]
        this.form.AEEouACP = ehTurmaAEEouACP(turma.cdtpatend, turma.cdinstruc, turma.cdserie)

      }
      else {
        this.form.AEEouACP = false
      }
    },
    checkAula() {
      let totalAulasFrequenciaLiberada = this.aulasCadastradas.filter( (aula) => {
          return ( aula['aberto'] && aula['liberadoFrequencia'] )
        } );

      (totalAulasFrequenciaLiberada.length !== this.aulasParaFrequencia.length) ? this.selecionarTodasAulas = 'N' :
      this.selecionarTodasAulas = 'S';

      const identificadorAula = this.aulasParaFrequencia[0]
      const aula = this.aulasCadastradas.filter( a => a.identificadoraula === identificadorAula)[0]
      if(aula) {
        const turmas = [...this.dadosTurmas]
        const turma = turmas.filter(t => t.cdturma === aula.cdturma)[0]
        this.form.AEEouACP = ehTurmaAEEouACP(turma.cdtpatend, turma.cdinstruc, turma.cdserie)

      }
      else {
        this.form.AEEouACP = false
      }
    },
    showCampoExperiencia() {
      return (this.form.cntpensin === 'I' && Number(this.form.aaletivo) >= 2020);
    },
    capitalizePeriodo (s) {
    if (typeof s !== 'string') return ''
    const text = s.split(' ');
    if (text.length == 2) {

      return `${text[0]} ${text[1].charAt(0).toUpperCase() + text[1].slice(1).toLocaleLowerCase()}`;
    }
    else {
      return s;
    }
  },
    setTipoEnsino() {
      if(this.turmasOptions.length) {
        const turma = this.turmasOptions.find(turma => turma.value === this.form.cdturma);
        this.form.cntpensin = turma.tipodeensino;
        if(this.form.cntpensin === 'I') {
          this.quantidadeAulasPermitidas = 10;
        } else {
          this.quantidadeAulasPermitidas = 6;
        }
      }
    },
    // Nesta tela, há o tratamento para Ens Fundamental e Ed Infantil porque é aqui que o usuário selecionará a turma, a turma é necessária para identificar se Ens fund ou Ed Infantil.
    //Não sendo assim possível fazer arquivos .vue separados para tratar cada tipo de ensino.
    atualizaTipoDeEnsino(array, cdturma) {
      if (this.form.cdturma) {
        this.form.cdinstruc = array.find(turma => turma.value == this.form.cdturma).cdinstruc;
        this.form.cdserie = array.find(turma => turma.value == this.form.cdturma).cdserie;
        this.tipodeensino = array.find(turma => turma.value == this.form.cdturma).tipodeensino;
        this.form.nmturma = array.find(turma => turma.value == this.form.cdturma).text;

        if (this.tipoDeEnsino === 'I') {
          this.form.indicapresencial = 'S';
        }
      }
    },
    fecharDialogFrequenciaPorDisciplina() {
      this.dialogPorTurma = false;
      this.aulasCadastradas = [];
      this.frequenciasALancar = [];
      this.aulasFrequenciaLancada = [];
    },
    fecharDialogFrequenciaPorTurma() {
      this.dialog = false;
      this.aulasCadastradas = [];
      this.frequenciasALancar = [];
      this.aulasFrequenciaLancada = [];
    },

    async loadTurmas(){
      this.loading = true;
      try{
        this.$Progress.start();
        const response = await DiarioEscolarRepository.getTurmas({ ...dadosUser(), aaletivo: this.form.aaletivo, nopaginate: true });
        this.dadosTurmas = response.data.results.turmasProfessor.data;
        this.form.cdinstruc = this.dadosTurmas.length ? this.dadosTurmas[0].cdinstruc : 0;
        this.form.cdserie = this.dadosTurmas.length ? this.dadosTurmas[0].cdserie : 0;
      }
      catch(e){ }
      this.loading = false;
      this.$Progress.finish();
    },
    async loadPeriodos(){
      this.loading = true;
      try{
        this.$Progress.start();

        if(this.lancamentoPorTurmaOuDisciplina === 'turma') {
          const response = await PeriodoAvaliativoRepository.getPeriodoTurmas({
            aaletivo: this.form.aaletivo,
            cdtipesc: this.form.cdtipesc,
            cdescola: this.form.cdescola,
            cdturma: this.form.cdturma,
            cdinstruc: this.form.cdinstruc,
          });
          this.periodoAvaliativo = response.data.results;
          this.CAA = response.data.fechamentos;
          this.indicamodelodeaula = response.data.configuracaoAnoLetivo.indicamodelodeaula;
            if(this.form.AEEouACP) {
              const alunosDaTurma = await TurmaRepository.getEnturmacao({
                aaletivo: this.form.aaletivo,
                cdtipesc: this.form.cdtipesc,
                cdescola: this.form.cdescola,
                cdturma: this.form.cdturma,
              })
              this.form.alunosDaTurma = alunosDaTurma.data.results.map( function(e) {
                                                                    return {
                                                                      key: e.numatalun,
                                                                      value: e.numatalun,
                                                                      title: e.nmaluno,
                                                                      disabled: false,
                                                                      selecionado: false
                                                                    }
                                                                  }
                                                               );

            }
        }
        else {
          const response = await PeriodoAvaliativoRepository.getPeriodoDisciplina({
            aaletivo: this.form.aaletivo,
            cdtipesc: this.form.cdtipesc,
            cdescola: this.form.cdescola,
            cddiscipl: this.form.cddiscipl,
          });
          this.periodoAvaliativo = response.data.results;
         // this.indicamodelodeaula = response.data.configuracaoAnoLetivo.indicamodelodeaula;
          this.configuracaoAnoLetivoPorInstrucao = response.data.configuracaoAnoLetivo;
        }

        if (this.indicamodelodeaula === 'P')
              this.form.indicapresencial = 'S';
         else if(this.indicamodelodeaula === 'R')
                  this.form.indicapresencial = 'N'
              else
                  this.form.indicapresencial = 'S';

      }
      catch(e){ }
      this.loading = false;
      this.$Progress.finish();
    },
    async loadTabela(){
      this.disciplinas = [];
      this.loading = true;
      this.$Progress.start();
      try{
        if(this.lancamentoPorTurmaOuDisciplina === 'disciplina') {
          const {data} = await TurmaRepository.getTurmasDaDisciplinaEPeriodoAvaliativo({
                                                                                        aaletivo: this.form.aaletivo,
                                                                                        cdtipesc: this.form.cdtipesc,
                                                                                        cdescola: this.form.cdescola,
                                                                                        cdpravadi: this.form.cdpravadi,
                                                                                        cddiscipl: this.form.cddiscipl,
                                                                                        cdpessoal: parseInt(this.form.cdpessoal),
                                                                                        cdmatric: parseInt(this.form.cdmatric),
                                                                                        identificadorperfilatual: this.userDadosPerfilAtual.identificadorperfil,
                                                                                      })
          let dadosTurmas = await _.clone(data.results);
          this.turmas = dadosTurmas
          this.turmasCopy = await _.clone(this.turmas);
          this.turmas.forEach(element => {
            if(element.AEEouACP) {
              this.obterAlunosDaTurmaAEEouACP(element)
              this.exibirDialogAlunos = false
            }
          });

        }
        else {
          const {data} = await DisciplinaRepository.getselectDisciplinaDoPeriodoAvaliativo({
                                                                                            aaletivo: this.form.aaletivo,
                                                                                            cdtipesc: this.form.cdtipesc,
                                                                                            cdescola: this.form.cdescola,
                                                                                            cdpravadi: this.form.cdpravadi,
                                                                                            cdinstruc: this.form.cdinstruc,
                                                                                            cdserie: this.form.cdserie,
                                                                                            cdturma: this.form.cdturma,
                                                                                            cdpessoal: parseInt(this.form.cdpessoal),
                                                                                            cdmatric: parseInt(this.form.cdmatric),
                                                                                            identificadorperfilatual: this.userDadosPerfilAtual.identificadorperfil,
                                                                                          })
          this.disciplinas = await _.map(data.results, (e) => e.disciplina)
          this.disciplinasCopy = await _.clone(this.disciplinas);
        }

      }
      catch(e){ }
      this.loading = false;
      this.$Progress.finish();
    },
    async LancarDetalhamento() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        this.errorTextDetalhamento = 'Preencha todos os campos corretamente.';
        this.$refs.alerta.scrollIntoView({ top: 0, behavior: 'smooth' });
        return;
      }
      this.errorTextDetalhamento = '';
      this.dialogDetalhamentoAula = false;
      this.dialogDetalhamentoFechando = true;
    },
    async CancelarDetalhamento() {
      this.copiarDetalhamento( this.formDetalhamentoCopia, this.form );
      this.errorTextDetalhamento = '';
      this.dialogDetalhamentoAula = false;
      this.dialogDetalhamentoFechando = true;
    },
    async abrirDialogDetalhamentoAula() {
      this.copiarDetalhamento( this.form, this.formDetalhamentoCopia );
      this.dialogDetalhamentoAula = true;
      if (this.$v.form.datareposicao.$invalid) {
        this.errorTextDetalhamento = 'Preencha todos os campos corretamente.';
      }
      this.$refs.alerta.scrollIntoView({ top: 0, behavior: 'smooth' });
    },
    async onSubmit(){
      this.validations.$touch();

      this.desabilitarSalvar = true;
      if (this.validations.$invalid) {
        this.errorText = 'Preencha todos os campos corretamente.';
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        this.desabilitarSalvar = false;
        return;
      }

      if(this.findCheck) {
        let turmas = [];
        let aulas =[];
        let disciplinas = [];

        if(this.lancamentoPorTurmaOuDisciplina === 'turma') {
             aulas = _.filter(this.disciplinas, (dis) => {
               return dis.check !== false && dis.dataaula !== '' && dis.descricaoassuntolecionado !== '';
            });

        }
        else if (this.lancamentoPorTurmaOuDisciplina === 'disciplina') {
            aulas = _.filter(this.turmas, (tur) => {
               return tur.check !== false && tur.dataaula !== '' && tur.descricaoassuntolecionado !== '';
            });

        }

        aulas = aulas.map( aula => {
          return {
            ...aula,
            dataaula: moment(aula.dataaula, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            datareposicao: (aula.datareposicao) ? moment(aula.datareposicao, 'DD/MM/YYYY').format('YYYY-MM-DD') : '' ,
          }
        })


        const aulasFormated = [];
        for(const key of aulas) {
          for(let i = 0; i < key.quantidade; i++) {

            if(key.AEEouACP) {
              key['alunosDaAula'] = this.form.alunosDaTurma.filter((e) =>  e.cdturma===key['cdturma'])
                                                            .map((e) => e.alunos)[0]
              key['alunosDaAula'] = _.filter(key['alunosDaAula'], function(e) {
                return e.selecionado === true
              })

            }
            aulasFormated.push(_.pick(key, [
              'aaletivo',
              'cdtipesc',
              'cdescola',
              'cdpessoal',
              'cdmatric',
              'cdturma',
              'cddiscipl',
              'cdpravadi',
              'dataaula',
              'descricaoassuntolecionado',
              'descricaodesenvolvimentoaula',
              'descricaorecursosutilizados',
              'descricaoatividadeassociada',
              'descricaoobjetivo',
              'datareposicao',
              'indicasituacao',
              'descricaoobservacao',
              'indicareposicao',
              'indicacampoexperiencia1',
              'indicacampoexperiencia2',
              'indicacampoexperiencia3',
              'indicacampoexperiencia4',
              'indicacampoexperiencia5',
              'indicapresencial',
              'alunosDaAula',
              ]
            ));
          }
        }

         turmas.push(this.form.cdturma);
         disciplinas.push(this.form.cddiscipl);

        try{
          this.loading = true;
          this.msgArrayError = [];
          let data = {};

            if (this.lancamentoPorTurmaOuDisciplina === 'turma') {
              const data1  = await DiarioEscolarRepository.postReplicarAulas({aaletivo: this.aaletivo,cdinstruc: this.form.cdinstruc, aulas: aulasFormated, turmas, regente: true, AEEouACP: this.form.AEEouACP, alunosDaAula: this.alunosSelecionados});
              data = data1.data;
            }
            else if (this.lancamentoPorTurmaOuDisciplina === 'disciplina') {
              const  data2 = await DiarioEscolarRepository.postReplicarAulasPorDisciplina({aaletivo: this.aaletivo,cdinstruc: this.form.cdinstruc, aulas: aulasFormated, disciplinas, regente: true});
              data = data2.data;

            }
          this.submitText = data.message;
          this.snackbar = true;
          //this.form.cdturma = 0;
          //this.form.cdturma = turmas[0];
          this.form.cdpravadi = aulas[0].cdpravadi;
          this.aulasCadastradas = [
            ...this.aulasCadastradas,
            ...data.aulas,
          ];
          this.limparDetalhamento();
        }
        catch(error){
          this.msgArrayError = [];
          if (error.response && error.response.data.status == 'ERROR_BUSINESS_RULE') {
            this.msgArrayError = error.response.data.errorMessage;
            if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
          }
        } finally {
          this.loading = false;
        }
      }
    },
    cancelar(){
      this.disciplinas = this.disciplinasCopy;
      this.turmas = this.turmasCopy;
      this.aulasCadastradas = [];
      this.frequenciasALancar = [];
      this.aulasFrequenciaLancada = [];
      this.opcoes = [];
      this.form.alunosDaTurma.forEach(function(e) {
                                                      for(let i=0; i <= Object.keys(e.alunos).length - 1; i++) {
                                                        e.alunos[i].selecionado = false
                                                      }

                                      })

      this.$v.$reset();
    },
    getTurno(data) {
      switch(data) {
        case 'M': return '- Matutino';
        case 'V': return '- Vespertino';
        case 'N': return '- Noturno';
        case 'I': return '- Integral';
        default: return '';
      }
    },
    findCheck(){
      return  _.find(this.disciplinas,{ 'check': true }) || _.find(this.turmas,{ 'check': true }) ;
    },
    msgValidacao(v){
      if(!v.required && v.$dirty)
        return ['Campo obrigatório'];
      if(typeof v.maxLength !== 'undefined' && !v.maxLength && v.$dirty)
        return ['O tamanho máximo é de 400 caracteres'];
      if(typeof v.minValue !== 'undefined' && !v.minValue && v.$dirty)
        return ['O valor mínimo deve ser 1'];
        if(typeof v.maxValue !== 'undefined' && !v.maxValue && v.$dirty)
        return [`O valor máximo deve ser ${this.quantidadeAulasPermitidas}`];
          if(typeof v.isValidDate !== 'undefined' && !v.isValidDate && v.$dirty)
            return [`Data inválida`];
    },
    resetRow(index) {
      const check = this.disciplinas[index].check;
      this.$v.disciplinas.$each[index].dataaula.$reset();
      this.$v.disciplinas.$each[index].descricaoassuntolecionado.$reset();

      if(this.form.cntpensin === 'I' /** TIPO DE ENSINO EDUCAÇÃO INFANTIL */) {
        this.disciplinas[index].dataaula = check ? (this.form.dataaula || '') : null;
        this.disciplinas[index].descricaoassuntolecionado = check ? (this.form.descricaoassuntolecionado || '') : null;
      } else {
        this.disciplinas[index].dataaula = '';
        this.disciplinas[index].descricaoassuntolecionado = '';
      }
      if (this.indicamodelodeaula === 'P')
      this.disciplinas[index].indicapresencial = 'S';
      else if(this.indicamodelodeaula === 'R')
              this.disciplinas[index].indicapresencial = 'N'
           else
            this.disciplinas[index].indicapresencial = 'S';

      if (this.form.cntpensin === 'I') {
        this.disciplinas[index].indicapresencial = check ? this.form.indicapresencial : null;
      }

      this.desabilitarSalvar = false;
      this.disciplinas[index].quantidade = (this.disciplinas[index].check) ? 1 : null;

    },
    resetRowTurma(index) {
      const check = this.turmas[index].check;
      this.$v.turmas.$each[index].dataaula.$reset();
      this.$v.turmas.$each[index].descricaoassuntolecionado.$reset();

      this.turmas[index].dataaula = check ? (this.turmas[index].dataaula || '') : null;
      this.turmas[index].descricaoassuntolecionado = check ? (this.turmas[index].descricaoassuntolecionado || '') : null;

      this.turmas[index].quantidade = (this.turmas[index].check) ? 1 : null;
      this.turmas[index].indicapresencial = 'S';
      this.desabilitarSalvar = false;


      let indicamodelodeaula = this.configuracaoAnoLetivoPorInstrucao.find( element => element.cdinstruc === this.dadosTurmas[index].cdinstruc)

      if (indicamodelodeaula.indicamodelodeaula === 'P')
      this.turmas[index].indicapresencial = 'S';
     else if(indicamodelodeaula.indicamodelodeaula === 'R')
          this.turmas[index].indicapresencial = 'N'
          else
            this.turmas[index].indicapresencial = 'S';
      this.turmas[index].indicamodelodeaula =  indicamodelodeaula.indicamodelodeaula;
    },
    async lancarFrequencia() {

      if(this.lancamentoPorTurmaOuDisciplina === 'turma') {
          if(this.aulasParaFrequencia.length > 0) {
          this.loadingFrequencia = true;

            await this.$root.$router.push({
              name: (this.form.AEEouACP) ? 'diario-escolar-aulas-frequencia-aee-acp' : 'diario-escolar-regente-frequencia',
              params: {
                ano: this.ano,
                cdturma: ( this.form.cdturma === '0') ? this.$props.cdturma : this.form.cdturma,
                nmturma: this.form.nmturma,
                tipoDeEnsino: this.form.cntpensin,
                aulas: this.aulasParaFrequencia,
                redirect: 'diario-escolar-regente',
                cdinstruc: this.form.cdinstruc,
                showLabelDisciplinaOuCampoExperiencia: false,
                aulasParaLancarFrequencia: this.aulasCadastradas,
                frequenciaLancada: this.aulasFrequenciaLancada,
                turmaOuDisciplina: this.lancamentoPorTurmaOuDisciplina,
                AEEouACP: this.form.AEEouACP,
              }
            });

      }

      }
      else if(this.lancamentoPorTurmaOuDisciplina === 'disciplina') {
        const dadosDaTurma = this.dadosTurmas.find(element => element.cdturma.trim() === this.form.cdturma.trim())
        const AEEouACP = ehTurmaAEEouACP(dadosDaTurma.cdtpatend, dadosDaTurma.cdinstruc, dadosDaTurma.cdserie)

               if(this.aulasParaFrequencia) {
                this.loadingFrequencia = true;
                await this.$root.$router.push({
                                                name: (AEEouACP) ? 'diario-escolar-aulas-frequencia-aee-acp' : 'diario-escolar-regente-frequencia',
                                                params: {
                                                  ano: this.ano,
                                                  cdturma: dadosDaTurma.cdturma,
                                                  nmturma: dadosDaTurma.nmturma,
                                                  disciplina: this.form.cddiscipl,
                                                  tipoDeEnsino: dadosDaTurma.cntpensin,
                                                  aulas: this.aulasParaFrequencia,
                                                  redirect: 'diario-escolar-regente',
                                                  cdinstruc: dadosDaTurma.cdinstruc,
                                                  showLabelDisciplinaOuCampoExperiencia: false,
                                                  aulasParaLancarFrequencia: this.aulasCadastradas,
                                                  frequenciaLancada: this.aulasFrequenciaLancada,
                                                  turmaOuDisciplina: this.lancamentoPorTurmaOuDisciplina,
                                                  AEEouACP: AEEouACP
                                                }
                                              });
                }
      }

    },
    copiarDetalhamento( origem, destino) {
      destino.descricaodesenvolvimentoaula =  origem.descricaodesenvolvimentoaula;
      destino.descricaorecursosutilizados =  origem.descricaorecursosutilizados;
      destino.descricaoatividadeassociada =  origem.descricaoatividadeassociada;
      destino.descricaoobjetivo =  origem.descricaoobjetivo;
      destino.indicareposicao =  origem.indicareposicao;
      destino.datareposicao =  origem.datareposicao;
      destino.indicasituacao =  origem.indicasituacao;
      destino.descricaoobservacao =  origem.descricaoobservacao;
    },
    limparDetalhamento() {
      this.form.descricaodesenvolvimentoaula =  '';
      this.form.descricaorecursosutilizados =  '';
      this.form.descricaoatividadeassociada =  '';
      this.form.descricaoobjetivo =  '';
      this.form.indicareposicao =  'N';
      this.form.datareposicao =  '';
      this.form.indicasituacao =  'E';
      this.form.descricaoobservacao =  '';
    },
    onClickInput(event, rowX) {
      this.linhaX = rowX;
      const items = document.querySelectorAll(
        `input[data-index="${rowX}"]`
      );
      for (const [index, item] of items.entries()) {
       // if (item.firstElementChild === event.target) {
       if (item === event.target) {
          return (this.linhaY = index);
        }
      }
    },
    onClickRadioButtonInput(event, rowX) {
      if (event.type === 'keyup') {
        return;
      }
      this.linhaX = rowX;
      const items = document.querySelectorAll(
        `input[data-index="${rowX}"]`
      );
      for (const [index, item] of items.entries()) {
       // if (item.firstElementChild === event.target) {
       if (item === event.target) {
          return (this.linhaY = index);
        }
      }
    },
    prevenirIncrementoInputNumber(e) {
      if(e.keyCode === 38 || e.keyCode === 40 )
         e.preventDefault();
      else return;

    },
    onKeyUp(key) {
      let rowX = this.linhaX;
      let rowY = this.linhaY;

       let fim = this.dadosTurmas.length;
      switch (key.keyCode) {
        case 37: //arrow left
          rowY--;
          fim = rowX + 1;
          break;
        case 38: //arrow up
          rowX--;
          fim = 0;
          break;
        case 39: //arrow right
          rowY++;
          fim = rowX + 1;
          break;
        case 40: //arrow down
          rowX++;
          break;
        default:
          return;
      }


      let items = [];
      for (
        rowX;
        (rowX >= 0 && rowX <= fim) || (key.keyCode == 38 && rowX > fim);
        rowX = key.keyCode == 38 ? rowX - 1 : rowX + 1
      ) {

        items = document.querySelectorAll(`input[data-index="${rowX}"]`);
        if (items.length > 0) {
          break;
        }
        else {
          //return;
        }
      }
      if (typeof items[rowY] === "undefined") {
        if(key.keyCode === 39) {

          rowX = rowX + 1;
          rowY = 0;
          items = document.querySelectorAll(`input[data-index="${rowX}"]`);
        }

       // return;
      }

      if (key.keyCode == 37 && rowY < 0) {
        rowX = (rowX <= 0) ? 0 : rowX - 1;
        items = document.querySelectorAll(`input[data-index="${rowX}"]`);
        rowY = items.length - 1;


      }

      this.linhaX = rowX;
      this.linhaY = rowY;

      let input = items[rowY];
      if (input)   input.focus();

    },
    toggle() {
      if (this.todosSelecionados) {
      this.opcoes = _.map(this.opcoes, function(e) {

                                                    return {
                                                            title: e.title,
                                                            value: e.value,
                                                            index: e.index,
                                                            selecionado: false,
                                                            disabled: e.disabled,
                                                            observacaoDesabilitado: e.observacaoDesabilitado
                                                    }


                                                  })
      }
      else {
        this.opcoes = _.map(this.opcoes, function(e) {
                                                         return {
                                                                  title: e.title,
                                                                  value: e.value,
                                                                  index: e.index,
                                                                  selecionado: (e.disabled) ? false : true,
                                                                  disabled: e.disabled,
                                                                  observacaoDesabilitado: e.observacaoDesabilitado
                                                              }

                                                      })

      }
    },
    exibirDialogListaDeAlunos(turma) {
      this.exibirDialogAlunos= true
      this.montarAlunosDialogBox(turma)
    },
    async obterAlunosDaTurmaAEEouACP(turma) {
      this.opcoes = []
      this.form.alunosDaTurma = []
      const dataaula = new Date(turma.dataaula).getTime()
      const {data} = await TurmaRepository.getEnturmacao({
        aaletivo: turma.aaletivo,
        cdtipesc: turma.cdtipesc,
        cdescola: turma.cdescola,
        cdturma: turma.cdturma,
      })

      const alunosDispensados = await DisciplinaDispensadaRepository.getAlunosDaTurmaDispensadosDaDisciplina({
                                                                                                            aaletivo: turma.aaletivo,
                                                                                                            cdtipesc: turma.cdtipesc,
                                                                                                            cdescola: turma.cdescola,
                                                                                                            cdturma: turma.cdturma,
                                                                                                            cddiscipl: turma.cddiscipl,
                                                                                                        })


        this.form.alunosDaTurma.push({cdturma: turma.cdturma,
                                      alunos: {...data.results.map(function(e) {
                                                let observacaoDesabilitado = ''
                                                let cdsitfim = parseInt(e.cdsitfim)
                                                let afastado = (cdsitfim === 6 || cdsitfim === 7 || cdsitfim === 8 || cdsitfim === 19 || cdsitfim === 23)
                                                let dtafastam = new Date(e.dtafastam).getTime()
                                                let ativoNaDataDaAula = (afastado) ? dataaula < dtafastam : true
                                                let disabled = (ativoNaDataDaAula) ? false : true
                                                let dispensado = alunosDispensados.data.results.filter( element => element.numatalun === e.numatalun).length > 0
                                                if(dispensado)  {
                                                  disabled = true
                                                  observacaoDesabilitado = 'DISPENSADO'
                                                }
                                                 else if(disabled) {
                                                    disabled = true
                                                    observacaoDesabilitado = e.situacaofinal

                                                  }
                                                                            return {
                                                                              title: e.nmaluno,
                                                                              value: e.numatalun,
                                                                              index: e.numatalun,
                                                                              selecionado: false,
                                                                              disabled: disabled,
                                                                              observacaoDesabilitado: observacaoDesabilitado,
                                                                              dtafastam: (e.dtafastam) ? new Date(e.dtafastam): '',

                                                                            }

                                                                        }) },

                                    })

    },
  montarAlunosDialogBox(turma) {
    this.cdturma_aux = turma.cdturma
    const index = this.form.alunosDaTurma.indexOf( this.form.alunosDaTurma.find( e => e.cdturma === this.cdturma_aux))

    if (index !== -1) {
      this.opcoes = this.form.alunosDaTurma[index].alunos

    }
    else {

      this.opcoes = this.form.alunosDaTurma.filter((e) => e.cdturma === turma.cdturma).map( (element) => element.alunos)[0]
      this.opcoes = Object.values(this.opcoes)
        this.opcoes = this.opcoes.map (function (e) {
          const dataaula = new Date(turma.dataaula).getTime()
          let dtafastam = (e.dtafastam !== '') ? e.dtafastam.getTime() : ''
          let disabled = ((e.disabled === true && dtafastam > 0 && dataaula > dtafastam) || e.observacaoDesabilitado ==='DISPENSADO' ) ? true : false
          let observacaoDesabilitado = (disabled === false) ? '' : e.observacaoDesabilitado

                return {

                  title: e.title,
                  value: e.value,
                  index: e.index,
                  selecionado: false,
                  disabled: disabled,
                  observacaoDesabilitado: observacaoDesabilitado,
                  dtafastam: e.dtafastam,

                }
        })
    }

  },
  fecharDialogo() {
    const index = this.form.alunosDaTurma.indexOf( this.form.alunosDaTurma.find( e => e.cdturma === this.cdturma_aux))
    this.form.alunosDaTurma[index].alunos = this.opcoes
    this.exibirDialogAlunos = false
  }

  },
  computed: {
    ...mapGetters(['userDadosPerfilAtual']),
    todosSelecionados() {
      return _.filter(this.opcoes, function(e) {
        return e.selecionado===true && e.disabled === false;
      }).length === _.filter(this.opcoes, function(e) {
        return  e.disabled === false;
      }).length

    },

    turmasOptions(){
      let turma = _.groupBy(this.dadosTurmas,'cdturma');
      let options = [];
      options.push({value: 0, text: 'Selecione', tipodeensino: null });
      for (const key in turma) {
          options.push({value: key, text: `${turma[key][0].nmturma} ${this.getTurno(turma[key][0].cnperiodo)}`, tipodeensino: turma[key][0].cntpensin, cdinstruc: turma[key][0].cdinstruc, cdserie: turma[key][0].cdserie  });
      }
      return options;
    },
    disciplinasOptions(){
      let disciplina = _.groupBy(this.dadosTurmas,'cddiscipl');
      let options = [];
      options.push({value: 0, text: 'Selecione', tipodeensino: null });
      for (const key in disciplina) {
          options.push({value: key, text: `${disciplina[key][0].dsdiscipl}`});
      }
      return options;
    },
    periodosOptions(){
      let periodos = this.periodoAvaliativo;
      let options = [];
      options.push({value: 0, text: 'Selecione' });
      for (let periodo of periodos) {
        options.push({value:periodo.cdpravadi, text:periodo.dspravadi});
      }
      return options;
    },
    tabela(){
      if(this.lancamentoPorTurmaOuDisciplina === 'turma') {
        if ( this.dialogDetalhamentoAula || ( !this.dialogDetalhamentoAula && this.dialogDetalhamentoFechando) ) {
          this.dialogDetalhamentoFechando = false;
          return this.disciplinas = this.disciplinas.map(key => ({ ...key, ...this.form, check: key.check, cddiscipl: key.cddiscipl, indicapresencial: key.indicapresencial }));
        }

        return this.disciplinas = this.disciplinas.map(key => ({  ...key, ...this.form,  quantidade: null, cddiscipl: key.cddiscipl }));
      }
      else {

        if(this.lancamentoPorTurmaOuDisciplina === 'disciplina') {

          if ( this.dialogDetalhamentoAula || ( !this.dialogDetalhamentoAula && this.dialogDetalhamentoFechando) ) {
            this.dialogDetalhamentoFechando = false;
            return this.turmas = this.turmas.map(key => ({ ...key, ...this.form, cdturma: key.cdturma, nmturma: key.nmturma, AEEouACP: ehTurmaAEEouACP(key.cdtpatend, key.cdinstruc, key.cdserie), check: key.check, indicapresencial: key.indicapresencial }));
          }
           return  this.turmas = this.turmas.map( key => ({  ...key,
                                                          ...this.form,
                                                          cdturma: key.cdturma,
                                                          nmturma: key.nmturma,
                                                          AEEouACP: ehTurmaAEEouACP(key.cdtpatend, key.cdinstruc, key.cdserie),
                                                          //temAlunoSelecionado: this.form.alunosDaTurma.filter(e => e.cdturma === key.cdturma).map(e => e.alunos).map((e, i) => e[i].selecionado).filter( function(e ) { console.log('e=', e)}),
                                                          // temAlunoSelecionado: () => {
                                                          //    const turma = this.form.alunosDaTurma.filter(e => e.cdturma === key.cdturma).pop()
                                                          //    const alunos = turma.alunos.toArray()
                                                          //    return alunos
                                                          // }  , //['alunos'].filter(e => e.selecionado === true),
                                                          check: key.check,
                                                          quantidade: null}));
        }
        else {
          return [];
        }
      }



    },
    validaSalvar(){
      let valida = this.findCheck();
      return this.form.cdpravadi == 0 || valida === undefined;
    },
    validarSelectPeriodos(){
      return (this.form.cdturma == 0 && this.form.cddiscipl == 0 ) || this.loading;
    },

    validations() {
      return (this.form.cntpensin === 'I' && this.form.cdturma) ?
                          this.$v.form
                        : (this.form.cdturma && this.form.cntpensin !== 'I') ?
                            this.$v.disciplinas
                          : this.$v.turmas
    }
  },
}
</script>

<style lang="scss">

.btn_icone_vermelho {
  background-color: #E64D4D;
    v-icon {
      color: #FFF;
    }
  &:disabled {
    background-color: transparent;
      v-icon {
        color: #bdbdbd
      }
  }
}

.btn_icone_verde {
  background-color: #01848C;
  &:disabled {
    background-color: transparent;
      v-icon {
        color: #bdbdbd
      }
  }
  v-icon {
      color: #FFF;
    }
}

  .btn-acoes-b {
    text-align: right;
    word-spacing: 20px;

    .v-btn {
      margin: 20px;

    }

    .teal {
      color:white;
    }
  }
  .text_center{
    input[type=text]{
      padding-left: 5px;
      text-align: left!important;
    }
  }

  .formDetalhamentoAula .input-block { width: 100%; }

  .assuntoLecionado { float: left; }

  .btnDetalhamento {
    margin: 10px 0px 0px 15px;
    min-width: 49px !important;
    height: 49px !important;
    padding: 0 0 !important;
  }

  @media only screen and (max-width: 700px) {
    .assuntoLecionado{ float: none; }
    .btnDetalhamento { margin: 0 0; float: right; }
  }

  .fixed {
    //position: -webkit-sticky;
    position: sticky;
    top: 10;
    z-index: 1;

    th {
      position: -webkit-sticky;
      position: sticky;
      top: -2px;
      z-index: 2;
      background: white;
    }

    tr {
      position: -webkit-sticky;
      position: sticky;
      top: 0 ;
      z-index: 0;
    }



  }

  // .fixed-n2 {
  //   position: -webkit-sticky;
  //   position: sticky;
  //   top: 100px;
  //   z-index: 1;
  //   tr {
  //     position: -webkit-sticky;
  //     position: sticky;
  //     top: 100px;
  //     z-index: 2;
  //     background: white;
  //   }
  // }

  .fixed-bottom {
   // position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1;
    background: white;

  }


</style>
